(() => {
  const init = (root) => {
    if (root.dataset.waxyVideoReady === 'true') return;
    const video = root.querySelector('video');
    const trigger = root.querySelector('[data-video-play]');
    if (!video || !trigger) return;
    root.dataset.waxyVideoReady = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const saveData = Boolean(connection && (connection.saveData || /^(slow-)?2g$/.test(connection.effectiveType || '')));
    let observer;
    trigger.hidden = false;
    const start = async () => {
      if (!video.getAttribute('src')) {
        const mobile = window.matchMedia('(max-width: 760px)').matches;
        const source = mobile ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        if (!source) return;
        video.muted = true;
        video.src = source;
        video.controls = false;
        video.load();
      }
      try {
        await video.play();
        trigger.textContent = trigger.dataset.pauseLabel;
      } catch (_) {
        trigger.hidden = false;
      }
    };
    trigger.addEventListener('click', () => { if (!video.paused && !video.ended) video.pause(); else start(); });
    video.addEventListener('play', () => { trigger.textContent = trigger.dataset.pauseLabel; });
    video.addEventListener('pause', () => { trigger.textContent = video.ended ? trigger.dataset.replayLabel : trigger.dataset.playLabel; });
    video.addEventListener('ended', () => {
      trigger.textContent = trigger.dataset.replayLabel;
      trigger.hidden = false;
    });
    motion.addEventListener('change', (event) => {
      if (event.matches) {
        if (observer) observer.disconnect();
        video.pause();
        trigger.hidden = false;
      }
    });
    if (motion.matches || saveData) return;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          start();
        }
      }, { threshold: 0.15 });
      observer.observe(video);
    } else {
      start();
    }
  };
  const initEnding = (root) => {
    if (root.dataset.waxyFilmReady === 'true') return;
    const video = root.querySelector('video');
    const copy = root.querySelector('.waxy-ending-copy');
    const button = root.querySelector('[data-ending-toggle]');
    if (!video || !copy || !button) return;
    root.dataset.waxyFilmReady = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const saveData = Boolean(connection && (connection.saveData || /^(slow-)?2g$/.test(connection.effectiveType || '')));
    let observer;
    button.hidden = false;
    const updateCopy = () => {
      const t = video.currentTime;
      const detail = video.readyState > 0 && !video.ended && (t < 1.1 || (t > 4.5 && t < 6.1) || (t > 9 && t < 17.2));
      root.dataset.filmDetail = String(detail);
      copy.inert = detail;
      copy.setAttribute('aria-hidden', String(detail));
    };
    const start = async () => {
      if (!video.getAttribute('src')) { video.src = video.dataset.src; video.muted = true; video.load(); }
      try { await video.play(); } catch (_) { button.textContent = button.dataset.playLabel; }
    };
    button.addEventListener('click', () => { if (!video.paused && !video.ended) video.pause(); else start(); });
    video.addEventListener('play', () => { button.textContent = button.dataset.pauseLabel; updateCopy(); });
    video.addEventListener('pause', () => { button.textContent = video.ended ? button.dataset.replayLabel : button.dataset.playLabel; });
    video.addEventListener('ended', () => { button.textContent = button.dataset.replayLabel; updateCopy(); });
    video.addEventListener('timeupdate', updateCopy);
    copy.addEventListener('focusin', () => { if (observer) observer.disconnect(); video.pause(); });
    motion.addEventListener('change', (event) => { if (event.matches) { if (observer) observer.disconnect(); video.pause(); } });
    if (motion.matches || saveData) return;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) { observer.disconnect(); start(); }
      }, { threshold: 0.3 });
      observer.observe(video);
    }
  };
  const scan = (scope) => {
    scope.querySelectorAll('[data-waxy-hero-video]').forEach(init);
    scope.querySelectorAll('[data-waxy-ending-film]').forEach(initEnding);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
